import sawlineApi from '../../api/sawline';
export default {
    namespaced: true,
    state: {
        flyScreenColorOptions: null,
        operationOptions: null,
    },
    actions: {
        fetchEditOptionsAsNeeded({ commit, dispatch, state }) {
            if (!state.flyScreenColorOptions || !state.operationOptions) {
                sawlineApi.fetchEditOptions().then((response) => {
                    const data = response.data.data;
                    state.flyScreenColorOptions = data.flyScreenColorOptions;
                    state.operationOptions = data.operationOptions;
                });
            }
        },
    },
    getters: {
        getFlyScreenColorOptions(state) {
            return state.flyScreenColorOptions;
        },
        getOperationOptions(state) {
            return state.operationOptions;
        },
    },
};
